import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appAmount]',
  standalone: true,
})
export class AmountDirective {
  @Input() appAmount: boolean = true;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputEvent(event: any) {
    if (this.appAmount) {
      let value = this.el.nativeElement.value?.replace(/[^0-9.]/g, '');
      const decimalCount = value?.split('.').length - 1;
      if (decimalCount > 1) {
        value = value?.replace(/\.([^.]*)$/, '$1');
      }
      const parts = value.split('.');
      if (parts[1]?.length > 2) {
        value = parts[0] + '.' + parts[1].substring(0, 2);
      }
      this.el.nativeElement.value = value;
    }
  }

  @HostListener('blur') onBlur() {
    if (this.appAmount && this.el.nativeElement.value) {
      const num = parseFloat(this.el.nativeElement.value);
      if (!isNaN(num)) {
        this.el.nativeElement.value = num.toFixed(2);
      }
    }
  }

  @HostListener('paste', ['$event']) onPasteEvent(event: ClipboardEvent) {
    if (this.appAmount) {
      event.preventDefault();
      const pastedText = (
        event.clipboardData || (window as any).clipboardData
      ).getData('text');
      let value = pastedText.replace(/[^0-9.]/g, '');
      const decimalCount = value.split('.').length - 1;
      if (decimalCount > 1) {
        value = value.replace(/\.([^.]*)$/, '$1');
      }
      const parts = value.split('.');
      if (parts[1]?.length > 2) {
        value = parts[0] + '.' + parts[1].substring(0, 2);
      }
      this.el.nativeElement.value = value;
    }
  }

  @HostListener('drop', ['$event']) onDropEvent(event: DragEvent) {
    if (this.appAmount) {
      event.preventDefault();
      const droppedText = event.dataTransfer?.getData('text');
      let value = droppedText?.replace(/[^0-9.]/g, '');
      if (!value) return;
      const decimalCount = value.split('.').length - 1;
      if (decimalCount > 1) {
        value = value.replace(/\.([^.]*)$/, '$1');
      }
      const parts = value.split('.');
      if (parts[1]?.length > 2) {
        value = parts[0] + '.' + parts[1].substring(0, 2);
      }
      this.el.nativeElement.value = value;
    }
  }
}
